import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from "react";
import FileDropzone from "../FileDropzone";
import classNames from "classnames";
import useMedia, { MediaSizes } from "../../../hooks/useMedia";
import AwesomeIcon from "../../AwesomeIcon";
import FilesList from "../FilesList";
import { formatDate } from "../../../utils";
import { cloneDeep, get, isEmpty, values } from "lodash";
import CardGroupIcon from "../CardGroupIcon";
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";
import MobileUpload from "./MobileUpload";
import { updateFileState } from "../utils";
import invalidFileError from "../InvalidError";
var ScanUpload = function ScanUpload(_ref) {
  var onDropFiles = _ref.onDropFiles,
    hasFilesSelected = _ref.hasFilesSelected,
    isSinglePatient = _ref.isSinglePatient,
    hasCurrentPatient = _ref.hasCurrentPatient,
    showLoading = _ref.showLoading,
    formattedSelectedFiles = _ref.formattedSelectedFiles,
    onAddFile = _ref.onAddFile,
    setIsGuidelineModal = _ref.setIsGuidelineModal,
    currentPatient = _ref.currentPatient,
    selectedFilesKeys = _ref.selectedFilesKeys,
    selectFileRef = _ref.selectFileRef,
    selectedFiles = _ref.selectedFiles,
    setSelectedFiles = _ref.setSelectedFiles,
    editRowId = _ref.editRowId,
    setEditRowId = _ref.setEditRowId;
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var _useState = useState(true),
    isSelectAll = _useState[0],
    setSelectAll = _useState[1];
  var toggleIsSelected = function toggleIsSelected(fileKey) {
    setSelectedFiles(function (prevState) {
      var nextSelectedFiles = cloneDeep(prevState);
      var fileObject = nextSelectedFiles[fileKey];
      updateFileState(fileKey, {
        isSelected: !fileObject.isSelected
      }, nextSelectedFiles);
      return nextSelectedFiles;
    });
  };
  var onSelectAll = function onSelectAll() {
    var nextIsSelectAll = !isSelectAll;
    var nextSelectedFiles = values(cloneDeep(selectedFiles)).reduce(function (acc, file) {
      if (file.isValidated) {
        file.isSelected = nextIsSelectAll;
      }
      if (!!file.fileKey) {
        acc[file.fileKey] = file;
      }
      return acc;
    }, {});
    setSelectedFiles(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), nextSelectedFiles);
    });
    setSelectAll(nextIsSelectAll);
  };
  return /*#__PURE__*/React.createElement(FileDropzone, {
    className: "h-full",
    onDropFiles: onDropFiles,
    isDropzoneDisabled: false,
    isHidden: false
  }, function (_ref2) {
    var open = _ref2.open;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classNames("sm:border rounded-md sm:border-gray-600 flex-1 !h-full", {
        "sm:!h-96 sm:border sm:border-gray-600 flex flex-col": hasFilesSelected && !isSinglePatient,
        "sm:!h-[300px] overflow-y-auto scrollbar-light dark:scrollbar": hasCurrentPatient && !hasFilesSelected && !isMobile || hasCurrentPatient
      })
    }, showLoading ? /*#__PURE__*/React.createElement("p", {
      className: classNames("text-gray-600 dark:text-gray-300 italic flex h-full justify-center items-center", {
        "hidden sm:flex": !hasFilesSelected || isSinglePatient
      })
    }, t("loading_scans"), "...") : /*#__PURE__*/React.createElement(React.Fragment, null, !hasFilesSelected || isSinglePatient && !hasCurrentPatient ? /*#__PURE__*/React.createElement("div", {
      className: classNames("flex flex-col sm:items-center justify-between text-gray-800 dark:text-white sm:h-full", {
        "!h-full": hasCurrentPatient
      })
    }, isEmpty(formattedSelectedFiles) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileUpload, {
      title: "button.upload_files",
      onAddFile: onAddFile,
      setIsGuidelineModal: setIsGuidelineModal
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames("flex-1 hidden sm:flex flex-col justify-center", {
        "hidden sm:block": isSinglePatient,
        "!flex !flex-col !items-center justify-center": hasCurrentPatient && isMobile
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-fit mx-auto"
    }, /*#__PURE__*/React.createElement(CardGroupIcon, null)), /*#__PURE__*/React.createElement("p", {
      className: "text-gray-600"
    }, t("import_scan_drag")))), hasCurrentPatient && !hasFilesSelected && /*#__PURE__*/React.createElement("p", null, "For ", currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.name), /*#__PURE__*/React.createElement("p", {
      className: "text-md py-5 text-gray-600 dark:text-gray-400"
    }, "(", t("import_scan_format"), ")"))) : /*#__PURE__*/React.createElement("div", {
      className: "hidden w-full flex-1 sm:!max-h-[280px] overflow-y-auto scrollbar-light dark:scrollbar sm:flex flex-col"
    }, selectedFilesKeys.map(function (fileKey, index) {
      var fileObject = formattedSelectedFiles[fileKey];
      var modality = get(fileObject, [0, "metaData", "Modality"], "");
      var studyDate = get(fileObject, [0, "metaData", "StudyDate"], "");
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "text-left p-5 border-b border-gray-600 space-y-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: "col-span-2 text-md text-gray-600 dark:text-white/50"
      }, t("study_details")), /*#__PURE__*/React.createElement("p", {
        className: "col-span-4 text-md"
      }, formatDate(studyDate))), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: "col-span-2 text-md text-gray-600 dark:text-white/50"
      }, t("series_instance")), /*#__PURE__*/React.createElement("div", {
        className: "col-span-4 items-center flex space-x-4"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-md"
      }, "".concat(modality)), /*#__PURE__*/React.createElement("div", {
        className: "flex space-x-2 items-center text-gray-700 dark:text-gray-500"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCopy,
        size: "xs"
      }), /*#__PURE__*/React.createElement("p", {
        className: "text-md"
      }, fileObject === null || fileObject === void 0 ? void 0 : fileObject.length)))), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: "col-span-2 text-md text-gray-600 dark:text-white/50"
      }, t("status")), /*#__PURE__*/React.createElement("div", {
        className: "col-span-4"
      }, invalidFileError({
        fileObject: fileObject
      }))));
    })), /*#__PURE__*/React.createElement("button", {
      onClick: open,
      "data-testid": "select-scans-button",
      className: "bg-gray-600 hidden sm:block text-gray-100 rounded-b-md h-fit py-4 hover:bg-gray-700 w-full"
    }, isEmpty(formattedSelectedFiles) ? t("select_scans") : t("add_more_scans"))) : /*#__PURE__*/React.createElement("div", {
      className: "flex-1 flex flex-col overflow-y-auto scrollbar-light dark:scrollbar"
    }, /*#__PURE__*/React.createElement(FilesList, {
      formattedSelectedFiles: formattedSelectedFiles,
      onSelectAll: onSelectAll,
      isSelectAll: isSelectAll,
      toggleIsSelected: toggleIsSelected,
      setSelectedFiles: setSelectedFiles,
      setEditRowId: setEditRowId,
      editRowId: editRowId,
      selectedFiles: selectedFiles,
      hasCurrentPatient: hasCurrentPatient
    })))), /*#__PURE__*/React.createElement("button", {
      ref: selectFileRef,
      hidden: true,
      onClick: open,
      type: "button"
    }, "fileInput"));
  });
};
export default ScanUpload;